import { useContext } from 'react';

import { useFragmentContext } from '@jsmdg/react-fragment-scripts/fragment';
import { PriceContext, type PriceContextValue } from '../contexts';
import { type ProductDetailContext } from '../types/types';

function createPriceContextBoundaryError(setter: string): never {
    throw new Error(`Calling ${setter} outside of the PriceProvider is not allowed`);
}

function usePrice(): PriceContextValue {
    const context = useContext(PriceContext);
    const { price } = useFragmentContext<ProductDetailContext>();

    if (context) {
        return context;
    }

    return {
        price,
        setAmount: () => {
            createPriceContextBoundaryError('setAmount');
        },
        setMultiplier: () => {
            createPriceContextBoundaryError('setMultiplier');
        },
    };
}

export { usePrice };
